module.exports = __webpack_public_path__ + "img/oem_preview_qrcode.07cf7217.png";